define('presentation/signup/presentationObjects/signupNumberPortPhoneNumberPresentationObject',[],function() {
    return function(){
        let self = this;

        self.phoneNumber = null;
        self.countryAbbreviation = "us";
    };
});

